import firebase from "firebase";
import {
  REACT_APP_API_KEY, REACT_APP_AUTH_DOMAIN,
  REACT_APP_DATABASE_URL, REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET, REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID, REACT_APP_MEASUREMENT_ID
} from '@env';
import { Units } from "./Unit";
export const tableNames = {
  level: "Levels",
  section: "Sections",
  question: "Questions",
  lessonForRFU: "LessonForReportsForUser",
  questionForRFU: "QuestionsForReportsForUser",
  practiceForRFU: "PracticeForReportsForUser",
  userClickedOnPremium: "hasUserClickedOnPremium",
  appsFlyerUserEvent: "AppsFlyerUserEvent",
  usersForAppDownloads: "UsersForAppDownloads",
  isContentDownloaded: "IsContentDownloaded",
  inAppReview: "InAppReviewForUser",
  eventsCount: "NumberOfEvents",
  userProfiles: "UserProfiles",
  enrollment: "Enrollments",
  aggregateQuestionData: "AggregateQuestionDataV2",
  aggregatePracticeTestResults: "AggregatePracticeTestResultsV2",
  customLessonMapping: "CustomLessonMapping"
};

export const webhookUrl =
  "https://hooks.zapier.com/hooks/catch/3401702/ox6nfdd/";

export const onlineUrl = Units.isIOS
  ? "https://hamradioprep.com/mobile?utm_source=ios&utm_medium=mobile&utm_campaign=react"
  : "https://hamradioprep.com/mobile?utm_source=android&utm_medium=mobile&utm_campaign=react";
export const findExamUrl =
  "https://www.arrl.org/find-an-amateur-radio-license-exam-session";
export const contactUsUrl = Units.isIOS
  ? "http://hamradioprep.com/mobile-app-support?utm_source=ios&utm_medium=mobile&utm_campaign=react"
  : "http://hamradioprep.com/mobile-app-support?utm_source=android&utm_medium=mobile&utm_campaign=react";
export const licenseUrl = Units.isIOS
  ? "https://hamradioprep.com/how-to-get-your-ham-radio-license-made-easy?utm_source=ios&utm_medium=mobile&utm_campaign=react"
  : "https://hamradioprep.com/how-to-get-your-ham-radio-license-made-easy?utm_source=android&utm_medium=mobile&utm_campaign=react";

export const firebaseConfig = {
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  databaseURL: REACT_APP_DATABASE_URL,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();

export const appsflyerConf = {
  devKey: "QLNwzyRVL4FvhA5or3s6ZU",
  isDebug: false,
  appId: "id1525090989",
  onInstallConversionDataListener: false,
  onDeepLinkListener: false,
};

export const eventForPremium = {
  eventName: "premium_course",
  eventValue: {
    content: "User visit a premium online course",
  },
};

export const eventForExam = {
  eventName: "final_exam_finished",
  eventValue: {
    content: "User finished a first final exam",
  },
};

export const eventForQuizFinished = {
  eventName: "quiz_finished",
  eventValue: {
    content: "User finished the quiz",
  },
};

export const videoUrl = "FindAnExam.mp4";

export const events = {
  noOfDownloads: "NumberOfDownloads",
  noOfLoginSucceed: "NumberOfLoginSucceed",
  noOfQuizFinished: "NumberOfQuizFinished",
  noOfPractice: "NumberOfPracticeFinished",
  noOfPremium: "NumberOfPremiumCourse",
};

export const storageImages = [
  "T1.jpeg",
  "T2.jpeg",
  "T3.jpeg",
  "E501.png",
  "E601.png",
  "E602.png",
  "E603.png",
  "E701.png",
  "E702.png",
  "E703.png",
  "E901.png",
  "E902.png",
  "E903.png",
  "General_Diagram.jpg",
  "FindAnExam.mp4",
];

export const renderLevel = [
  {
    LevelId: 1,
    Name: "Technician License",
    ShortDesc: "Updated for 2022",
    id: "uDBNGCjyqit98hECx24v",
  },
  // {
  //   LevelId: 2,
  //   Name: "General License",
  //   ShortDesc: "Prerequisite: Technician",
  //   id: "7yPtaVP9F1QjPJonol4q"
  // },
  {
    LevelId: 3,
    Name: "Amateur Extra License",
    ShortDesc: "The final class.",
    id: "3UZQCmKtSKO2kBY1FXcc",
  },
  {
    LevelId: 4,
    Name: "Technician License (2022 - 2026)",
    ShortDesc: "Beginners start here!",
    Status: true,
    id: "uDBNGCjyqit98hECx24v-new",
  },
  {
    LevelId: 5,
    Name: "General License (2023 - 2027)",
    ShortDesc: "Upgrade to General and expand your privileges.",
    Status: true,
    id: "7yPtaVP9F1QjPJonol4q-new",
  },
  {
    LevelId: 6,
    Name: "Amateur Extra (2024 - 2028)",
    ShortDesc: "The final class.",
    Status: true,
    id: "d0891411db834651a53baa679477e7bd-new",
  },
  {
    LevelId: 7,
    Name: "Technician License (2026 - 2030)",
    ShortDesc: "Beginners start here!",
    Status: true,
    id: "ItoakfZgAA1K0HJavPl7",
  },
]

export const ADMIN_USER = ["criticalcommunicationsmedia@gmail.com", "jamesbluebandit@yahoo.com"];

export const authInfo = {
  email: "test@user.com",
  password: "123456789",
};


export const LevelGroupMapping = {
  level4: [
    "T0A",
    "T0B",
    "T0C",
    "T1A",
    "T1B",
    "T1C",
    "T1D",
    "T1E",
    "T1F",
    "T2A",
    "T2B",
    "T2C",
    "T3A",
    "T3B",
    "T3C",
    "T4A",
    "T4B",
    "T5A",
    "T5B",
    "T5C",
    "T5D",
    "T6A",
    "T6B",
    "T6C",
    "T6D",
    "T7A",
    "T7B",
    "T7C",
    "T7D",
    "T8A",
    "T8B",
    "T8C",
    "T8D",
    "T9A",
    "T9B"
  ],
  level5: [
    "G0A",
    "G0B",
    "G1A",
    "G1B",
    "G1C",
    "G1D",
    "G1E",
    "G2A",
    "G2B",
    "G2C",
    "G2D",
    "G2E",
    "G3A",
    "G3B",
    "G3C",
    "G4A",
    "G4B",
    "G4C",
    "G4D",
    "G4E",
    "G5A",
    "G5B",
    "G5C",
    "G6A",
    "G6B",
    "G7A",
    "G7B",
    "G7C",
    "G8A",
    "G8B",
    "G8C",
    "G9A",
    "G9B",
    "G9C",
    "G9D"
  ],
  level6: [
    "E0A",
    "E1A",
    "E1B",
    "E1C",
    "E1D",
    "E1E",
    "E1F",
    "E2A",
    "E2B",
    "E2C",
    "E2D",
    "E2E",
    "E3A",
    "E3B",
    "E3C",
    "E4A",
    "E4B",
    "E4C",
    "E4D",
    "E4E",
    "E5A",
    "E5B",
    "E5C",
    "E5D",
    "E6A",
    "E6B",
    "E6C",
    "E6D",
    "E6E",
    "E6F",
    "E7A",
    "E7B",
    "E7C",
    "E7D",
    "E7E",
    "E7F",
    "E7G",
    "E7H",
    "E8A",
    "E8B",
    "E8C",
    "E8D",
    "E9A",
    "E9B",
    "E9C",
    "E9D",
    "E9E",
    "E9F",
    "E9G",
    "E9H"
  ]
}